import { Circle, ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import React from "react";

export default function LogAccordionShell({
  title,
  customAdornment,
  children,
  defaultExpanded,
  customTitle,
  onOpen,
  isExpanded,
}) {
  return (
    <Accordion
      className="relative mr-2 w-full bg-white"
      defaultExpanded={!defaultExpanded ? false : defaultExpanded}
      expanded={isExpanded === (customTitle ? customTitle : title)}
      onChange={onOpen ? onOpen(customTitle ? customTitle : title) : null}
    >
      <AccordionSummary
        className="relative z-[0]"
        expandIcon={
          <div className="flex items-center">
            {customAdornment ? <Circle className={`text-${customAdornment}-300`} /> : ""}
            <ExpandMore />
          </div>
        }
        aria-controls={`${customTitle ? customTitle : title}-content`}
        id={`${customTitle ? customTitle : title}-header`}
      >
        {title}
      </AccordionSummary>
      <AccordionDetails className="mx-2 border-t border-gray-300">{children}</AccordionDetails>
    </Accordion>
  );
}
